export default function PreparationItemReportController(
  $q,
  $rootScope,
  $scope,
  alerts,
  amDataService,
  amSharedModelService,
  confirmDialog,
  docDataService,
  loaderService,
  orgDataService,
  ssDialogService
) {
  const vm = this;

  // Set Default Values
  vm.canExpand = vm.status !== 'No Preparation Item Report Added';
  vm.isExpanded = false;
  vm.canDeleteItem = vm.canDelete;

  // Attach Event Handlers
  vm.handleUnattachPreparationItemReport = _handleUnattachPreparationItemReport;
  vm.handleConfirmDelete = _handleConfirmDelete;
  vm.handleCancelDelete = _handleCancelDelete;

  function _handleUnattachPreparationItemReport($event) {
    ssDialogService.dialogs.auditTrail.deletePreparationItemReportConfirmDialog = ssDialogService.alert(
      confirmDialog.getOptions($event, {
        dialogTitle: 'Remove Attached Report?',
        message: `Are you sure you want to remove Report "${vm.preparationItemReport.name}"?`,
        handleYesClick: _handleConfirmDelete,
        handleNoClick: _handleCancelDelete,
      })
    );

    ssDialogService.show(ssDialogService.dialogs.auditTrail.deletePreparationItemReportConfirmDialog);
  }

  function _handleConfirmDelete() {
    loaderService.showViewLoader = true;
    return amDataService.detachPreparationItemReport(vm.preparationItemReport.preparationItemReportInstanceId)
      .then(() => {
        alerts.success('The report has been removed successfully.');
        $rootScope.$broadcast('refreshAMPreparationItemReports',
          { preparationItemId: vm.preparationItemReport.preparationItemId });
        _closeDeleteDialog();
      }).catch(() => {
        alerts.error('Error occurred while removing the report.');
      }).finally(() => {
        loaderService.showViewLoader = false;
      });
  }

  function _handleCancelDelete() {
    _closeDeleteDialog();
  }

  function _closeDeleteDialog() {
    ssDialogService.hide(ssDialogService.dialogs.auditTrail.deletePreparationItemReportConfirmDialog);
  }
}

PreparationItemReportController.$inject = [
  '$q',
  '$rootScope',
  '$scope',
  'alerts',
  'amDataService',
  'amSharedModelService',
  'confirmDialog',
  'docDataService',
  'loaderService',
  'orgDataService',
  'ssDialogService'
];
